// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconCheck = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 16 16' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M8 14.665A6.666 6.666 0 0 0 14.667 8 6.666 6.666 0 0 0 8 1.332a6.666 6.666 0 0 0-6.667 6.667A6.666 6.666 0 0 0 8 14.665m2.943-7.89-3.334 3.333a.62.62 0 0 1-.883 0L5.06 8.441a.625.625 0 0 1 .883-.883l1.224 1.225 2.89-2.894a.625.625 0 0 1 .883.883z'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconCheck)
const Memo = memo(ForwardRef)
export default Memo
